// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"767":"961b5463","788":"16080e8b"}[chunkId] + ".js";
};